import { AxiosResponse, AxiosStatic } from "axios";

import { IPatchPayload, IPatchResponse } from "../../components/course-author/helpers/patches";
import { ICreationResponse, IFullStyle } from "../../parsers/resolve";

export interface IStylesApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface IStylesApi {
  create: (fullStyle: IFullStyle, accountId: string) => Promise<AxiosResponse<ICreationResponse<IFullStyle>>>;
  getEditableByRelativeTo: (accountId: string, organizationId: string) => Promise<AxiosResponse<string[]>>;
  getStylesForOrganization: (accountId: string, organizationId: string, version: string) => Promise<AxiosResponse>;
  patchStyle: (accountId: string, styleId: string, patch: IPatchPayload) => Promise<AxiosResponse<IPatchResponse>>;
}

export default class StylesApi implements IStylesApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IStylesApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public create = (fullStyle: IFullStyle, accountId: string): Promise<AxiosResponse<ICreationResponse<IFullStyle>>> => {
    return this.axios.post(`${this.apiRoot}/styles`, fullStyle, {
      params: { activeUser: accountId },
    });
  };

  public getStylesForOrganization = (accountId: string, organizationId: string, version: string) => {
    return this.axios.get(`${this.apiRoot}/assets/styles/${organizationId}/${version}/custom.css`, {
      params: { activeUser: accountId },
    });
  };

  public getEditableByRelativeTo = (accountId: string, organizationId: string): Promise<AxiosResponse<string[]>> => {
    return this.axios.get(
      `${this.apiRoot}/collections/styles/editableBy/${accountId}/relativeToOrg/${organizationId}`,
      {
        params: { activeUser: accountId },
      }
    );
  };

  public patchStyle = (
    activeUser: string,
    styleId: string,
    patchPayload: IPatchPayload
  ): Promise<AxiosResponse<IPatchResponse>> => {
    return this.axios.post(`${this.apiRoot}/styles/${styleId}/_patches`, patchPayload, {
      params: { activeUser },
    });
  };
}
